import React from 'react';

export default (props) => {
    return (
        <div className="form-field">
            <label htmlFor={props.name}>{props.label}</label>
            <textarea rows="5" type="text" name={props.name} id={props.name} onChange={props.onChange} disabled={props.disabled} />
        </div>
    )
}